export default function isDeputyXeroEmbed() {
  return window.__APP__.INTEGRATIONS?.isDeputyXeroEmbed;
}
